<p-toast></p-toast>
<div class="container-fluid maap-root-container">
    <app-header [showWitness]="true"></app-header>
    <app-sidebar></app-sidebar>

    <div style="margin-top: 73px; margin-left: 84px;" class="content-area">
        <div class="header" *ngIf="!showAddItems && !selectedMedication">
            <div class="header-title-row">
                <h1 class="standalone-page-title">Monitored Item Groups</h1>
                <p-button *ngIf="canEdit()" label="Add new item group" styleClass="add-supplement-btn" (onClick)="openAddItems()"></p-button>
            </div>
        </div>
        <hr class="section-divider" *ngIf="!showAddItems && !selectedMedication">

        <app-med-table *ngIf="!selectedMedication && !showAddItems" (rowSelected)="onRowSelected($event)"></app-med-table>
        <app-medication-details *ngIf="selectedMedication && !showAddItems" [medication]="selectedMedication" [canEdit]="canEdit()" (back)="goBackToTable()"></app-medication-details>
        <app-add-items *ngIf="showAddItems" (back)="goBackToTable()"></app-add-items>
    </div>

</div>
